






















import Vue from 'vue';
import ServicePromise from '../../plugins/servicelayer/responseTypes/serviceResponse';
import _ from '../../utils';

export default Vue.extend({
  props: {
    src: { type: undefined, default: undefined },
    // String, Function or Promise
    apiSrc: { type: undefined, default: undefined },
    cover: { type: Boolean, default: true },
    contain: { type: Boolean, default: false },
    height: { type: [Number, String], default: undefined },
    width: { type: [Number, String], default: undefined },
    maxHeight: { type: [Number, String], default: undefined },
    maxWidth: { type: [Number, String], default: undefined },
    alt: { type: String, default: undefined },
    ratio: { type: [Number, String], default: undefined },
    to: { type: String, default: undefined },
  },
  data: () => ({
    internalSrc: undefined as string | undefined,
    isLoading: false,
    isError: false,
  }),
  computed: {
    classList() {
      return {
        'p-img': true,
        cover: this.cover && !this.contain,
        contain: this.contain,
      };
    },
    styleList() {
      return {
        height: (this as any).parseWidthHeight(this.height),
        width: (this as any).parseWidthHeight(this.width),
        maxHeight: (this as any).parseWidthHeight(this.maxHeight),
        maxWidth: (this as any).parseWidthHeight(this.maxWidth),
      };
    },
    imgStyleList() {
      // Hide it so it still loads but doesn't take up space
      const isHidden = this.isLoading || this.isError;
      return {
        height: isHidden ? '0px' : undefined,
        width: isHidden ? '0px' : undefined,
        visibility: isHidden ? 'hidden' : undefined,
        position: isHidden ? 'absolute' : undefined,
      };
    },
  },
  watch: {
    src: {
      immediate: true,
      handler() {
        if (this.src && (this.src as any as File).type?.startsWith('image/')) {
          const reader = new window.FileReader();
          reader.readAsDataURL(((this.src as unknown) as Blob));
          reader.onload = () => {
            const imageDataUrl = reader.result;
            this.internalSrc = imageDataUrl as string;
          };
        }
        this.internalSrc = this.src;
        this.setLoading();
      },
    },
    apiSrc: {
      immediate: true,
      handler() {
        if (!this.apiSrc) {
          return;
        }
        const apiSrc = this.apiSrc as any;
        this.setLoading();
        const self = this as any;
        let promise: Promise<ServicePromise<any>>;
        if (typeof this.apiSrc === 'function') {
          promise = apiSrc();
        } else if (_.isPromise(this.apiSrc)) {
          promise = apiSrc;
        } else {
          promise = this.$service.get(apiSrc, { responseType: 'blob' });
        }

        promise.then((response) => {
          const reader = new window.FileReader();
          const blobData = response.data ?? response;
          reader.readAsDataURL(((blobData as unknown) as Blob));
          reader.onload = () => {
            const imageDataUrl = reader.result;
            self.internalSrc = imageDataUrl;
          };
        })
          .catch(() => {
            self.setError();
          });
      },
    },
  },
  mounted() {
    const img = this.$refs.image as Element;
    img.addEventListener('load', this.setComplete);
    img.addEventListener('error', this.setError);
  },
  beforeDestroy() {
    const img = this.$refs.image as Element;
    img.removeEventListener('load', this.setComplete);
    img.removeEventListener('error', this.setError);
  },
  methods: {
    setLoading() {
      this.isLoading = true;
      this.isError = false;
    },
    setError() {
      this.isError = true;
      this.isLoading = false;
    },
    setComplete() {
      this.isLoading = false;
      this.isError = false;
    },
    parseWidthHeight(number: number | string) {
      if (this.ratio !== undefined) {
        return undefined;
      }
      if (number === undefined) {
        return undefined;
      }
      if (typeof number === 'string') {
        if (number.includes('%') || number.includes('px')) {
          return number;
        }
        const parsedNumber = parseInt(number, 10);
        if (!Number.isNaN(parsedNumber)) {
          return `${parsedNumber}px`;
        }
        return number;
      }
      return `${number}px`;
    },
  },
});
